import React, {forwardRef, ReactNode} from 'react';

import {useLocalize} from '../../../../libs/shared/core/src/helpers/internationalization/internationalizationContext';
import {defineMessage} from '../../../../libs/shared/core/src/helpers/internationalization/message';

/*
 * Props.
 */

interface CellsRegionProps {
  className?: string;
  children?: ReactNode;
}

/*
 * Component.
 */

export const CellsRegion = forwardRef<HTMLDivElement, CellsRegionProps>((props, ref) => {
  const localize = useLocalize();

  return (
    <div
      ref={ref}
      className={props.className}
      role="region"
      aria-label={localize(
        defineMessage({
          id: 'cells-region',
          message: 'Conversations',
        }),
      )}
    >
      {props.children}
    </div>
  );
});
